import React from 'react';
import { Chip, Avatar, java, spring, springboot, html, css, js, jquery, reactjs, sass, docker, springData, springSecurity, mongodb, sql, node, express, nest, ts } from './Imports';

function renderBadge({ label, src }) {
    return (
        <Chip
            key={label}
            avatar={<Avatar alt={label} src={src} />}
            label={label}
            variant="outlined"
            className="badge"
        />
    );
}

function About() {
    const badgesData = [
        { label: 'Java', src: java },
        { label: 'Spring Core/MVC', src: spring },
        { label: 'Spring Boot', src: springboot },
        { label: 'Spring Data', src: springData },
        { label: 'Spring Security', src: springSecurity },
        { label: 'ReactJS', src: reactjs },
        { label: 'jQuery', src: jquery },
        { label: 'JavaScript', src: js },
        { label: 'Nodejs', src: node },
        { label: 'Expressjs', src: express },
        { label: 'TypeScript', src: ts },
        { label: 'Nestjs', src: nest },
        { label: 'Sass', src: sass },
        { label: 'HTML', src: html },
        { label: 'CSS', src: css },
        { label: 'Docker', src: docker },
        { label: 'SQL', src: sql },
        { label: 'MongoDB', src: mongodb },
    ];

    return (
        <>
            <div className='about'>
                <header className="sectionName">
                    <div className='line' />
                    <h3><em>About Me</em></h3>
                    <div className='line' />
                </header>
                <div className="abtContainer">
                    <div className='badges'>
                        {badgesData.map(renderBadge)}
                    </div>
                    <div className="brief">
                        <p>
                            {/* As a Full-Stack Developer specializing in Java with proficiency in frameworks & modules like Spring Core/MVC, Spring Data, Spring Security, Spring Boot and Hibernate, I bring a comprehensive skill set to the table.<br />
                            My expertise extends to front-end technologies including React.js, JavaScript, and jQuery, enabling me to craft dynamic and user-friendly interfaces.<br />
                            With a solid background in designing and implementing solutions across diverse domains, I possess a deep understanding of core concepts and tools such as CI/CD Pipelines, Docker.<br />
                            I streamline development processes, integrate technologies seamlessly, and collaborate across teams to deliver scalable software solutions efficiently, translating requirements into robust and innovative solutions.<br />
                            If you're interested in discussing anything related to software development or exploring potential collaborations, feel free to reach out. You can initiate a conversation by emailing me at <strong><em>er.ayandhiman@gmail.com</em></strong>.<br /> */}
                            <div style={{ textAlign: 'left' }}>As a Full-Stack Developer with deep expertise in Java and a strong command of frameworks and modules such as Spring Core & MVC, Spring Data JPA, Spring Security, and Spring Boot, I offer a well-rounded and versatile skill set.
                            My back-end proficiency is complemented by my expertise in front-end technologies like React.js, JavaScript, and jQuery, allowing me to create dynamic and user-friendly interfaces that enhance user experiences.</div><br/>
                            <div style={{ textAlign: 'right' }}>In addition to my Java expertise, I have upskilled in Node.js, Express.js, TypeScript, and Nest.js, further expanding my ability to build robust, scalable, and efficient software solutions.
                            My experience spans across designing and implementing solutions in diverse domains, where I have consistently demonstrated a deep understanding of core concepts and tools such as CI/CD pipelines and Docker.</div><br/>
                            <div style={{ textAlign: 'left' }}>I am committed to streamlining development processes, integrating technologies seamlessly, and collaborating effectively across teams to deliver innovative software solutions.
                            I thrive on translating complex requirements into robust, scalable, and efficient software, ensuring that every project I undertake is executed with precision and excellence.</div><br/>
                            If you're interested in discussing anything related to software development or exploring potential collaborations, feel free to reach out to me at <strong><em>er.ayandhiman@gmail.com</em></strong>.
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default About;